export default __webpack_public_path__ + "static/media/noun-coach.1db83700.svg";